/**
 * * Модель тега
 */
export class TagModel {
  /**ID тега */
  Id!: number;
  /**Название тега */
  Name!: string;
  /**Цвет */
  Color: string = "#0D9336";
  /**Описаение */
  Description?: string;

  constructor(obj?: Partial<TagModel>) {
    Object.assign(this, obj);
  }
}
